import React from 'react';
import { Space, Skeleton, Typography, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import SelectableListButton from '../SelectableListButton';

const { useBreakpoint } = Grid;

export default function NoteTypeTemplatesTab({
  templatesLoading,
  userTemplates,
  selectedTemplate,
  onSelectTemplate
}) {
  const { t } = useTranslation();
  const { Paragraph } = Typography;
  const screens = useBreakpoint();
  const getTemplateSubtitle = (template) => {
    if (!screens.sm) return null;
    const content = template.getContent();
    if (!content) return null;
    return content.length > 60 ? content.substring(0, 60) + '...' : content;
  };

  if (templatesLoading) {
    return (
      <Space direction="vertical" data-testid="templates-skeleton" style={{ width: '100%', display: 'flex', paddingTop: '15px' }}>
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} style={{ padding: '12px', marginBottom: '8px', border: '1px solid #f0f0f0', borderRadius: '8px' }}>
            <Skeleton active title={{ width: '60%' }} paragraph={{ rows: 1, width: '80%' }} />
          </div>
        ))}
      </Space>
    );
  }

  

  if (userTemplates.length === 0) {
    if (screens.xs) {
      return (
        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
          <img src="https://img.icons8.com/plasticine/100/template.png" alt="template-empty" />
          <Paragraph type="secondary" style={{ marginTop: 12, textAlign: 'center' }}>
            {t('note_templates.empty_state')}
          </Paragraph>
        </div>
      );
    }
    return <div style={{ width: '100%', height: '100%' }} />;
  }

  return (
    <div style={{ 
      width: '100%', 
      maxHeight: '450px', 
      overflowY: 'auto', 
      padding: '15px 0px', 
      paddingRight: '8px' 
    }}>
      <Space direction="vertical" style={{ width: '100%', display: 'flex' }}>
        {userTemplates.map((template) => (
          <SelectableListButton
            key={template.getUUID()}
            title={template.getName()}
            subtitle={getTemplateSubtitle(template)}
            isSelected={!screens.xs && selectedTemplate && selectedTemplate.getUUID() === template.getUUID()}
            onClick={() => onSelectTemplate(template)}
            testId={`template-button-${template.getUUID()}`}
          />
        ))}
      </Space>
    </div>
  );
}


